import React from 'react';
import ContentLoader, { type IContentLoaderProps } from 'react-content-loader';
import { animationSpeed } from '~/src/components/skeletons/caption-block-skeleton/caption-block-skeleton.constants';
import {
    imgBlockBorderRadius,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/banner-loaders/image-loader/image-loader.constants';
import {
    skeletonBackgroundColor,
    skeletonForegroundColor,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/knowledge-base-banners-skeleton.constants';

export const ImageLoader = (props: IContentLoaderProps) => {
    return (
        <ContentLoader
            speed={animationSpeed}
            width={props.width || '500'}
            height={props.height || '350'}
            viewBox={`0 0 ${props.width || '500'} ${props.height || '350'}`}
            backgroundColor={skeletonBackgroundColor}
            foregroundColor={skeletonForegroundColor}
            {...props}
        >
            <rect
                x="0"
                y="0"
                rx={imgBlockBorderRadius}
                ry={imgBlockBorderRadius}
                width={props.width || '500'}
                height={props.height || '350'}
            />
        </ContentLoader>
    );
};
